import { render, staticRenderFns } from "./AllVault.vue?vue&type=template&id=747fc070&"
import script from "./AllVault.vue?vue&type=script&lang=js&"
export * from "./AllVault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports